const selectors = {
  addToCartButton: '.product-form__submit',
  notifyMeButton: '.button--notify-me',
  closeButton: '[data-close-notify-me]',
  notifyMeVariants: '[data-notify-me-variants]',
  form: '[data-notify-me-form]',
  popupSuccess: '#popup-success',
  popupError: '#popup-error',
  popupBody: '#popup-body',
  popupReset: '[data-notify-me-reset]'
};

const classes = {
  visuallyHidden: 'visually-hidden',
  active: 'active',
}

class NotifyMe extends BaseDrawer {
  constructor() {
    const globalSelectors = {
      triggerButton: '.button--notify-me',
      drawer: '[data-notify-me-drawer]',
      overlay: '[data-notify-me-drawer-overlay]'
    };
    super(globalSelectors);
    if (!window.theme.notifyMe.enable) return;

    this.addToCartButton = document.querySelector(selectors.addToCartButton);
    this.notifyMeButton = document.querySelector(selectors.notifyMeButton);
    this.drawer = document.querySelector(globalSelectors.drawer);
    this.notifyMeVariants = this.drawer.querySelector(selectors.notifyMeVariants);
    this.form = this.drawer.querySelector(selectors.form);
    this.popupBody = this.drawer.querySelector(selectors.popupBody);
    this.popupSuccess = this.drawer.querySelector(selectors.popupSuccess);
    this.popupError = this.drawer.querySelector(selectors.popupError);
    this.popupReset = this.drawer.querySelector(selectors.popupReset);
    if (!this.addToCartButton || !this.notifyMeButton) return;

    this.authUrl = 'https://auth.au-aws.thewishlist.io/auth/realms/superette-new-zealand/protocol/openid-connect/token';
    this.accessToken = null;

    this.initNotifyMe();

    if(this.popupReset) {
      this.popupReset.addEventListener('click', this.resetNotifyMe.bind(this));
    }
  }

  close() {
    super.close();
    this.resetNotifyMe();
    this.resetFields();
  }

  openWithProduct(productData, selectedVariantId = null) {
    const titleElement = this.drawer.querySelector('.caption--strong');
    if (titleElement && productData.title) {
      titleElement.textContent = productData.title;
    }

    this.populateVariants(productData.variants || [], selectedVariantId);
    window.currentProduct = productData;
    this.open();
  }

  populateVariants(variants, selectedVariantId = null) {
    if (!this.notifyMeVariants) return;

    this.notifyMeVariants.innerHTML = '';

    variants.forEach(variant => {
      const option = document.createElement('option');
      option.value = variant.id;
      option.textContent = variant.title;

      if (selectedVariantId && variant.id == selectedVariantId) {
        option.selected = true;
      }

      this.notifyMeVariants.appendChild(option);
    });

    const selectContainer = this.notifyMeVariants.closest('.custom-select');
    if (selectContainer) {
      if (variants.length <= 1) {
        selectContainer.classList.add('small-hide', 'medium-hide', 'large-up-hide');
      } else {
        selectContainer.classList.remove('small-hide', 'medium-hide', 'large-up-hide');
      }
    }
  }

  initNotifyMe() {
    this.onVariantChangeUnsubscriber = subscribe(
      PUB_SUB_EVENTS.variantChange,
      this.handleOptionValueChange.bind(this)
    );

    this.form.addEventListener('submit', this.submitNotifyMeForm.bind(this));
  }

  handleOptionValueChange(event) {
    const variantIsNotifyMe = event.data?.variant?.available;
    this.activeVariantId = event.data?.variant?.id;

    this.notifyMeButton.classList.toggle(classes.visuallyHidden, variantIsNotifyMe);
    this.addToCartButton.classList.toggle(classes.visuallyHidden, !variantIsNotifyMe);

    this.notifyMeVariants.value = this.activeVariantId;

    if(!variantIsNotifyMe) return;
  }

  resetNotifyMe() {
    this.popupBody.classList.remove(classes.visuallyHidden);
    this.popupSuccess.classList.add(classes.visuallyHidden);
    this.popupError.classList.add(classes.visuallyHidden);
  }

  resetFields() {
    this.form.reset();
  }

  async getAccessToken() {
    // Check if we have a valid token in sessionStorage
    const storedToken = sessionStorage.getItem('notifyMeToken');
    const storedTimestamp = sessionStorage.getItem('notifyMeTokenTimestamp');

    if (storedToken && storedTimestamp) {
      const tokenAge = Date.now() - parseInt(storedTimestamp);
      const fiveHours = 5 * 60 * 60 * 1000;

      if (tokenAge < fiveHours) {
        this.accessToken = storedToken;
        return storedToken;
      }
    }

    // If we get here, we need a new token
    const params = new URLSearchParams({
      grant_type: 'client_credentials',
      client_id: 'twc_admin',
      client_secret: window.theme.notifyMe.client_secret
    });

    try {
      const response = await fetch(this.authUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: params
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      this.accessToken = data.access_token;

      // Store the new token and timestamp
      sessionStorage.setItem('notifyMeToken', data.access_token);
      sessionStorage.setItem('notifyMeTokenTimestamp', Date.now().toString());

      return this.accessToken;
    } catch (error) {
      console.error('Error getting access token:', error);
      throw error;
    }
  }

  async submitNotifyMeForm(event) {
    event.preventDefault();

    if (!this.notifyMeVariants.value) {
      return;
    }

    try {
      // Get fresh access token before making the API call
      const token = await this.getAccessToken();

      const formData = {
        variantRef: this.notifyMeVariants.value,
        email: this.form.querySelector("input[name='email']").value,
        subscribe: this.form.querySelector("input[name='mailList']").checked,
        notifyMe: true,
        firstName: this.form.querySelector("input[name='firstName']").value,
        lastName: this.form.querySelector("input[name='lastName']").value,
        mobile: this.form.querySelector("input[name='mobile']").value
      };

      const url = 'https://api.au-aws.thewishlist.io/services/wsservice/api/wishlist/items/customerInterest';

      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
          'X-Twc-Tenant': window.theme.notifyMe.tenant_id,
          'Accept': 'application/json',
        },
        mode: 'cors',
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        this.popupBody.classList.add(classes.visuallyHidden);
        this.popupError.classList.remove(classes.visuallyHidden);
        throw new Error(`HTTP error! status: ${response.status}`);
      } else {
        this.popupBody.classList.add(classes.visuallyHidden);
        this.popupSuccess.classList.remove(classes.visuallyHidden);
      }

    } catch (error) {
      console.error('Error submitting form:', error);
    }
  }
}

customElements.define('notify-me', NotifyMe);